import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import '../../App.css';

const DEFAULT_SUPPORT_EMAIL = 'suporte@barukknow.com';

export const SupportContactPage: React.FC = () => {
  const { publicTenant } = useAuth();

  const supportEmail = process.env.REACT_APP_SUPPORT_EMAIL || DEFAULT_SUPPORT_EMAIL;
  const tenantName = publicTenant?.name?.trim();
  const tenantLogo = publicTenant?.logoUrl?.trim();

  return (
    <div className="login-page-container">
      <div className="login-logo-top">
        {tenantLogo
          ? <img src={tenantLogo} alt={tenantName || 'Logo'} className="h-8 w-auto" />
          : <span className="logo-box">b</span>}
        <span className="logo-text">{tenantName || 'Know inDoc'}</span>
      </div>
      <div className="login-left">
        <div className="w-full" role="status">
          <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-blue-100 mb-4">
            <svg
              className="h-6 w-6 text-blue-700"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              aria-hidden="true"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M18.364 5.636a9 9 0 010 12.728m0 0l-2.829-2.829m2.829 2.829L21 21M15.536 8.464a5 5 0 010 7.072m0 0l-2.829-2.829m-4.243 2.829a9 9 0 010-12.728m0 0l2.829 2.829m-2.829-2.829L3 3"
              />
            </svg>
          </div>
          <h2 className="login-greeting text-center">Estamos quase lá</h2>
          <p className="login-subtitle text-center text-gray-600">
            Ainda não há nenhum produto liberado para
            {tenantName ? ` ${tenantName}` : ' a sua empresa'}. É provável que o ambiente
            esteja em fase de implantação. Para liberar o acesso, fale com o nosso suporte.
          </p>
          <div className="flex justify-center mt-6">
            <a
              href={`mailto:${supportEmail}`}
              className="inline-flex items-center justify-center rounded-md bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700"
            >
              Falar com o suporte
            </a>
          </div>
          <p className="login-subtitle text-center text-gray-500 mt-4">
            Ou escreva para{' '}
            <a href={`mailto:${supportEmail}`} className="text-blue-600 hover:underline">
              {supportEmail}
            </a>
            .
          </p>
        </div>
      </div>
      <div className="login-right" />
    </div>
  );
};
